import React from 'react'
import { Search } from 'lucide-react'
import { useSearchStore } from '../../../store/useSearchStore'

const SearchBar = () => {
  // const [searchQuery, setSearchQuery] = useState('')
  // const [filteredClients, setFilteredClients] = useState([])
  const { searchQuery, setSearchQuery } = useSearchStore()

  return (
    <div>
      {/* Search Bar */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 pr-4 py-2 w-full md:w-64 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
        />
      </div>
    </div>
  )
}

export default SearchBar
